<template>
  <nav class="navbar navbar-fixed-top" role="navigation">
    <div class="container-1200">
      <div class="navbar-header">
        <a class="navbar-brand" href="https://www.ctbcbank.com/">
          <img class="img-responsive" src="@/common/img/etag/topbar_logo_CTBC.png" alt="中國信託銀行">
        </a>
      </div>

      <div class="navbar-nav navbar-right" v-if="$store.state.showGoHome">
        <div class="nav-item"><a href="#" @click.prevent="homePage">回首頁</a></div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  computed: {
  },
  methods: {
    homePage () {
      this.$router.replace({ name: 'P1', query: '' })
    }
  }
}
</script>

<style scoped>

</style>
